import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GlobalSessionData } from "../../interfaces/sessiondatamapper";
import DistributorService from "../../services/distributorservice";
import { useLocation } from "react-router-dom";
import { operations as commondataoperations, selectors as globalDataSelector } from "../../state/features/common/globaldata";
import { selectors as headerSelector } from "../../state/features/header";
import { selectors as homeSelector } from "../../state/features/home";
import { IsEmpty } from "../../utils/string";
import CommonControl from "./CommonControl";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../const/resource";
import helperfunctions from "../../utils/helperfunctions";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import '../ConfirmDailog/style.scss';
import { confirmDailog } from "../ConfirmDailog";
import { useNavigate } from "react-router-dom";
import { IAppContextProps } from "../App/AppInterface";
import { useAppContext } from "../App/App";
interface Iprops {
    isShopingCartUpdate?: boolean
    isFromShoppingCart?: boolean
    setIsUpdateButtonEnable?: any
    setIsShopingCartUpdate?: any
    setCurrentViewModal?: any
    isUpdateClick?: any
    isCheckoutPage?: any
    shoppingcartOnClick?:any
}

const CommonControlContainer = (props?: Iprops) => {
    const locationpageName = useLocation().pathname;
    const navigate = useNavigate();
    const getComponetsName = () => {
        let substringlocationpageName = (locationpageName != undefined && locationpageName != "") ? locationpageName.substring(1, locationpageName.length) : "";
        let getComponentsName = (substringlocationpageName != undefined && substringlocationpageName != "") ?
            substringlocationpageName.charAt(0).toUpperCase() + substringlocationpageName.slice(1) : "";

        if (substringlocationpageName == "machinedetails") {
            setgetBreadcrubPage(t(RESOURCE.MyK_Menu_MyFleet));
        } else if (substringlocationpageName == "promotionviewall") {
            setgetBreadcrubPage(t(RESOURCE.MyK_Promotion_BreadcrumbHeader));
        } else if (substringlocationpageName == "mydocuments") {
            setgetBreadcrubPage("My Documents");
        } else {
            setgetBreadcrubPage(getComponentsName);
        }
        setgetBreadcrubPageactual(substringlocationpageName);
    };
    const { headercurrentuser, distributorData }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
        distributorData: globalDataSelector.distributordata(state),
    }));

    const { t } = useTranslation();
    const [getBreadcrubPage, setgetBreadcrubPage] = useState("");
    const [getBreadcrubPageactual, setgetBreadcrubPageactual] = useState("");
    const userRoleType = headercurrentuser?.usertype?.name ?? "customer";
    const dispatch = useDispatch();
    const dispatchsetGlobalData = commondataoperations.dispatchCurrentGlobalData(dispatch);
    const dispatchDistributorData = commondataoperations.dispatchDistributorData(dispatch);
    const [distributorCheck, setDistributorCheck] = useState(false);
    const [customerCheck, setCustomerCheck] = useState(false);
    const [locationsCheck, setLocationsCheck] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLocationLoading, setIsLocationLoading] = useState<boolean>(false);
    const [isCustomerLoading, setIsCustomerLoading] = useState<boolean>(false);
    const [isSessionUpdateLoading, setIsSessionUpdateLoading] = useState<boolean>(false);
    const [isSessionGetLoading, setIsSessionGetLoading] = useState<boolean>(false);
    const {isWacMixedFleetDistributor }: IAppContextProps = useAppContext();
    const initialValues = {
        distributors: t(RESOURCE.MyK_Label_AllDistributors),
        distributorCode: "",
        distributorId: "",
        customer: t(RESOURCE.MyK_Label_AllCustomers),
        customerId: "",
        locations: t(RESOURCE.MyK_Label_AllLocations),
        locationId: "",
    };
    const [values, setValues] = useState(initialValues);

    const initialState = [{ id: "", name: "", selected: "", dbId: "" }];
    let optionsDistributor = [
        {
            value: t(RESOURCE.MyK_Label_AllDistributors),
            title: t(RESOURCE.MyK_Label_AllDistributors),
        },
    ];
    let optionsCustomers = [
        {
            value: t(RESOURCE.MyK_Label_AllCustomers),
            title: t(RESOURCE.MyK_Label_AllCustomers),
        },
    ];
    let optionsLocations = [
        {
            value: t(RESOURCE.MyK_Label_AllLocations),
            title: t(RESOURCE.MyK_Label_AllLocations),
        },
    ];  
    const [userId, setUserId] = useState(headercurrentuser?.azureADId ?? "");
    useEffect(() => {
        setUserId(headercurrentuser?.azureADId ?? "");
    }, [headercurrentuser?.azureADId]);

    useEffect(() => {
        if (!isSessionGetLoading)
            getSessionData();
    }, [userId]);

    const uType = headercurrentuser?.usertype?.id || "";
    const [distributorOptions, setDistributorOptions] = useState(initialState);
    const [customerOptions, setCustomerOptions] = useState(initialState);
    const [locationOptions, setLocationOptions] = useState(initialState);
    const [updateSessionData, setUpdateSessionData] = useState<GlobalSessionData>({} as GlobalSessionData);

    const getDataValue = (value: any) => {
        return value ?? "";
    }

    const checkNullOrEmptyValue = (value: any) => {
        return !value || value == "";
    }

    const checkDistributor = (response: any) => {
        if (!IsEmpty(response?.DistributorCode)) {
            setDistributorCheck(true);
            setCustomerCheck(false);
            setLocationsCheck(false);
            getCustomer(userId, response?.DistributorCode);
        }
    }

    const checkCustomer = (response: any) => {
        if (response?.CustomerId > 0 && response?.CustomerId != "") {
            setDistributorCheck(true);
            setCustomerCheck(true);
            setLocationsCheck(false);
            getLocation(
                userId,
                response?.DistributorCode != ""
                    ? response?.DistributorCode
                    : headercurrentuser?.dbid?.toString(),
                response?.CustomerId,
                response
            );
        }
    }

    const checkLocation = (response: any) => {
        if (
            response?.LocationId > 0 &&
            response?.LocationId != "" &&
            response?.CustomerId != "" &&
            response?.DistributorCode != ""
        ) {
            setDistributorCheck(true);
            setCustomerCheck(true);
            setLocationsCheck(true);
        }
    }

    const getDistributorNameFromDistributorData = (response: any) => {
        let distributorArray = Object.values(distributorData).filter(
            (value) => typeof value === "object"
        );
        const selectedDistributor: any = distributorArray?.find((t: any) => t?.dbId == response?.DistributorId || t?.id == response?.DistributorCode);
        let distributorName = selectedDistributor?.name ?? response?.DistributorName;
        return distributorName;
    }

    const getDistributorName = (response: any) => {
        let distSessionName = response?.DistributorName == 'All Distributors' ? t(RESOURCE.MyK_Label_AllDistributors) : getDistributorNameFromDistributorData(response);
        return (response?.DistributorName == null || response?.DistributorName == "")
            ? t(RESOURCE.MyK_Label_AllDistributors)
            : distSessionName;
    }

    const getCustomerName = (response: any) => {
        return (!response?.CustomerId ||
            !response?.CustomerName ||
            response?.CustomerId == 0 ||
            response?.CustomerId == "")
            ? t(RESOURCE.MyK_Label_AllCustomers)
            : response?.CustomerName ?? response?.CustomerId
    }

    const getLocationName = (selLocation: any) => {
        return ((selLocation.length == 0 || !selLocation)
            ? t(RESOURCE.MyK_Label_AllLocations)
             : getMainLocationName(selLocation));
    }

    const getMainLocationName = (location: any) => {
        if (location.length == 1) {
            return location[0]?.name ?? location[0]?.id
        }
        else {
            let mainLocation = getMainOrFirstLocation(location);
            return (mainLocation ? mainLocation?.name ?? mainLocation?.id : 0)
        }
    }

    const getMainLocation = (location: any) => {
        let mainLocation = getMainOrFirstLocation(location);
        return (mainLocation ? mainLocation?.id??0 : 0)
    }

    const getMainOrFirstLocation = (location: any) => {
        return location?.find((s:any) => s.selected) ?? location?.length >= 1 ? location[0] : null;
    }

    const checkLocationAndUpdateValue = (response: any) =>
    {
        if (
            localStorage.getItem("locations") != undefined &&
            localStorage.getItem("locations") != "" &&
            response?.LocationId != undefined &&
            response?.LocationId != ""
        ) {
            let selLocation = JSON.parse(
                localStorage.getItem("locations") ?? "[initialState]"
            )?.filter((l: any) => l.id == response?.LocationId?.toString());
            setValues((prevState) => ({
                ...prevState,
                distributors: getDistributorName(response),
                distributorCode: getDataValue(response?.DistributorCode),
                distributorId: response?.DistributorId ?? 0,
                customer: getCustomerName(response),
                customerId: getDataValue(response?.CustomerId),
                locations: getLocationName(selLocation),
                locationId: selLocation.length == 1 ? selLocation[0]?.id : getMainLocation(selLocation),
            }));
        } else {
            setValues((prevState) => ({
                ...prevState,
                distributors: getDistributorName(response),
                distributorCode: getDataValue(response?.DistributorCode),
                distributorId: response?.DistributorId ?? 0,
                customer: getCustomerName(response),
                customerId: getDataValue(response?.CustomerId),
            }));
        }
    }


    const checkDistributorCustomeLocation = (response: any) => {
        checkDistributor(response);
        checkCustomer(response);
        checkLocation(response);

        if (
            !IsEmpty(response?.DistributorCode) ||
            (checkNotZeroOrEmpty(response?.CustomerId)) ||
            (checkNotZeroOrEmpty(response?.LocationId))
        )
        {
            checkLocationAndUpdateValue(response);
        }

        if (
            userRoleType?.toLowerCase() == "customer" && !headercurrentuser?.isWideAreaUser &&
            (checkZeroOrEmpty(response?.LocationId)) &&
            checkNotUndefinedOrEmpty(localStorage.getItem("locations"))
        ) {
            setLocationsCheck(true);
            let selLocation = JSON.parse(
                localStorage.getItem("locations") ?? "[initialState]"
            );

            let islocationAvailable = selLocation.length == 1;
            let locId = islocationAvailable ? selLocation[0]?.id : getMainLocation(selLocation);
            let locName = islocationAvailable ? selLocation[0]?.name : getMainLocationName(selLocation);
            setUpdateSessionData((prevState) => ({
                ...prevState,
                LocationId: locId,
                LocationName: locName,
                isClear: false,
            }));

            dispatchsetGlobalData({
                LocationId: locId,
                LocationName: locName,
            });

            setValues((prevState) => ({
                ...prevState,
                locations:(selLocation.length == 0 || !selLocation) 
                        ? t(RESOURCE.MyK_Label_AllLocations)
                        : locName,
                locationId: locId,
            }));
        }
    }

    const checkNotZeroOrEmpty = (value: any) => {
        return (value != "0" && !IsEmpty(value));
    }

    const checkZeroOrEmpty = (value: any) => {
        return (value == "0" || value == "");
    }

    const checkNotUndefinedOrEmpty = (value: any) => {
        return (value != undefined && value != "");
    }

    const checkNotUndefinedOrNullEmpty = (value: any) => {
        return (value != undefined && value !=null && value != "");
    }

    const checkNullEmptyorZero = (value: any) => {
        return (value == "" || value == null || value == 0);
    }

    const setLocationSessionAndValue = (locationId: any, locationName: any) => {
        setValues((prevState) => ({
            ...prevState,
            locations: locationName,
            locationId: locationId
        }));
        setUpdateSessionData((prevState) => ({
            ...prevState,
            LocationId: locationId,
            LocationName: locationName,
            isClear: false,
        }));

    }

    const checkDistributoConditionForSession = (response :any) => {
        return (userRoleType?.toLowerCase() == "distributor" && !headercurrentuser?.isMultiDistributor && (
            response?.DistributorName != headercurrentuser?.companyName ||
            response?.DistributorCode != headercurrentuser?.dbid ||
            response?.DistributorId != headercurrentuser?.companyId
        ))
    }

    const checkCustomerConditionForSession = () => {
        return (userRoleType?.toLowerCase() == "customer" && !headercurrentuser?.isWideAreaUser)
    }

    const getSessionData = () => {
        if (checkNotUndefinedOrNullEmpty(userId)) {
            setIsSessionGetLoading(true);
            DistributorService.getSessionData(userId)
                .then(async (response: any) => {
                    setIsSessionGetLoading(false);
                    if (checkCustomerConditionForSession()) {
                        if (checkNullEmptyorZero(response?.CustomerId)) {
                            response.CustomerId = headercurrentuser?.custId?.toString();
                        }
                        response.DistributorCode = checkNullOrEmptyValue(response.DistributorCode) ? headercurrentuser?.dbid : response.DistributorCode;
                    }

                    if (checkDistributoConditionForSession(response)) {
                        response.DistributorId = headercurrentuser?.dbid;
                        response.DistributorCode = headercurrentuser?.dbid;
                        response.DistributorName = headercurrentuser?.companyName;
                        response.CustomerId = "";
                        response.CustomerName = "";
                        response.LocationId = "";
                        response.LocationName = "";
                    }

                    setUpdateSessionData((prevState) => ({
                        ...prevState,
                        DistributorId: getDataValue(response?.DistributorId),
                        DistributorCode: getDataValue(response?.DistributorCode),
                        DistributorName: getDataValue(response?.DistributorName),
                        CustomerId: getDataValue(response?.CustomerId),
                        CustomerName: getDataValue(response?.CustomerName),
                        LocationId: getDataValue(response?.LocationId),
                        LocationName: getDataValue(response?.LocationName),
                        BranchCode: getDataValue(response?.BranchCode),
                        BranchName: getDataValue(response?.BranchName),
                        isClear: false,
                    }));

                    dispatchsetGlobalData({
                        DistributorId: getDataValue(response?.DistributorId),
                        DistributorCode: getDataValue(response?.DistributorCode),
                        DistributorName: getDataValue(response?.DistributorName),
                        CustomerId: getDataValue(response?.CustomerId),
                        CustomerName: getDataValue(response?.CustomerName),
                        LocationId: getDataValue(response?.LocationId),
                        LocationName: getDataValue(response?.LocationName),
                        BranchCode: getDataValue(response?.BranchCode),
                        BranchName:getDataValue(response?.BranchName)
                    });

                    checkDistributorCustomeLocation(response);
                })
                .catch((e: any) => {
                    setIsSessionGetLoading(false);
                });
        }
    };

    const setSessionData = () => {
        if (
            updateSessionData != undefined &&
            Object.keys(updateSessionData).length != 0 &&
            userId != undefined &&
            userId != null
        ) {
            dispatchsetGlobalData(updateSessionData);
            setIsLoading(true);
            setIsSessionUpdateLoading(true);
            DistributorService.setSessionData(userId, updateSessionData)
                .then(async (response: any) => {
                    setIsSessionUpdateLoading(false);
})
                .catch((e: any) => {
                    setIsSessionUpdateLoading(false);
                });
        }
    };

    const clearAllFields = () => {
        if (!props?.isFromShoppingCart) {
            DistributorService.clearSessionData(userId)
                .then(async (response: any) => { })
                .catch((e: any) => { });
        }
        const userRole = userRoleType?.toLowerCase();
        if (userRole == "company" || userRole == "employee" || headercurrentuser.isWideAreaUser || headercurrentuser.isMultiDistributor) {
            handleOnChange(t(RESOURCE.MyK_Label_AllDistributors), [t(RESOURCE.MyK_Label_AllDistributors)], "distributors");
        }
        else if (userRole == "customer" && !headercurrentuser.isWideAreaUser && !headercurrentuser.isMultiDistributor) {
            handleOnChange(t(RESOURCE.MyK_Label_AllLocations), [t(RESOURCE.MyK_Label_AllLocations)], "locations");
        }
        else {
            handleOnChange(t(RESOURCE.MyK_Label_AllCustomers), [t(RESOURCE.MyK_Label_AllCustomers)], "customer");
        }
    };

    const getDistributorList = (userId: any) => {
        setIsLoading(true);
        DistributorService.getDistributors(userId)
        .then(async (response: any) => {
            setDistributorOptions(await response);
            dispatchDistributorData(await response);
            setIsLoading(false);
        })
        .catch((e: any) => { 
            setIsLoading(false);
        });
    }

    const getDistributor = () => {
        if (userId) {
            getDistributorList(userId);
        }
        if (
            headercurrentuser?.usertype != undefined &&
            uType != "1" &&
            !headercurrentuser?.isWideAreaUser &&
            !headercurrentuser?.isMultiDistributor &&
            headercurrentuser?.dbid != null
        ) {
            getCustomer(userId, headercurrentuser?.dbid?.toString());
            setValues({
                ...values,
                distributors: distributorOptions?.filter((c) => c.id == headercurrentuser?.dbid)[0]?.name,
                distributorCode: headercurrentuser?.dbid?.toString(),
                distributorId: headercurrentuser?.dbid
            });
        } else if (
            headercurrentuser?.usertype != undefined &&
            uType == "3" &&
            !headercurrentuser?.isWideAreaUser
        ) {
            getLocation(userId, headercurrentuser?.dbid?.toString(), headercurrentuser?.custId);
            setValues({
                ...values,
                customer: customerOptions?.filter((c) => c.id == headercurrentuser?.custId)[0]?.name,
                customerId: headercurrentuser?.custId,
            });
        }
    };

    const getCustomer = (userId: string, distcode: string) => {
        if (distcode != undefined && distcode != null && distcode != "") {
            setIsLoading(true);
            setIsCustomerLoading(true);
            DistributorService.getCustomers(userId, distcode, props?.isFromShoppingCart ? "false" : "true")
                .then(async (response: any) => {
                    setCustomerOptions(await response);
                    setIsCustomerLoading(false);
                })
                .catch((e: any) => {
                    setIsCustomerLoading(false);
                });
        }
    };
    const getLocation = (
        userId: string,
        distcode: string,
        custCode: string,
        selectedData: any = null
    ) => {
      
        if (checkNotUndefinedOrNullEmpty(distcode) && checkNotUndefinedOrNullEmpty(custCode)) {
            setIsLoading(true);
            setIsLocationLoading(true);
            DistributorService.getLocation(userId, distcode, custCode, props?.isFromShoppingCart ? "false" : "true")
                .then((response: any) => {
                    setLocationData(response, selectedData);
                })
                .catch((e: any) => {
                    setIsLocationLoading(false);
                });
        }
    };

    const setLocationData = (response: any, selectedData: any = null) => {
        setLocationOptions(response);
        localStorage.removeItem("locations");
        localStorage.setItem("locations", JSON.stringify(response));
        if (selectedData) {
            let locations = t(RESOURCE.MyK_Label_AllLocations);
            let locationName = "";
            if (checkZeroOrEmpty(selectedData?.LocationId)) {
                if (response?.length == 1) {
                    locations = response[0]?.id
                    locationName = response[0]?.name
                    setUpdateSessionData((prevState) => ({
                        ...prevState,
                        LocationId: locations,
                        LocationName: locationName,
                        isClear: false,
                    }));
                }
                else if (response?.length > 1) {
                    locations = getMainLocation(response);
                    locationName = getMainLocationName(response);
                    setUpdateSessionData((prevState) => ({
                        ...prevState,
                        LocationId: locations,
                        LocationName: locationName,
                        isClear: false,
                    }));
                }
                else {
                    locations = t(RESOURCE.MyK_Label_AllLocations)
                }

            } else {
                const loc = response?.find((s: any) => s.id == selectedData?.LocationId)
                locations = loc?.id
                locationName = loc?.name
            }

            setValues((prevState) => ({
                ...prevState,
                locations: locationName,
                locationId: locations
            }));

            setLocationsCheck(true);
        }
        else {
            if (response?.length == 1) {
                setLocationSessionAndValue(response[0]?.id, response[0]?.name);
                setLocationsCheck(true);
            }
            else if (response?.length >= 1) {
                let mainLocation = getMainLocation(response);
                let mainLocationName = getMainLocationName(response);
                setLocationSessionAndValue(mainLocation, mainLocationName);
                setLocationsCheck(true);
            }
        }
        setIsLocationLoading(false);
    }


    const handleOnChange = (value: any, title: any, name: string, extra: any = {}) => {
        const distributor:any = name ==='distributors' ? extra : distributorOptions.find((t) => t?.dbId === extra?.dbId);
        const paths = ['/shoppingcart', '/shoppingcart/quotes', '/shoppingcart/punchouthistory', '/shoppingcart/savedpartslist', '/shoppingcart/komatsucredithistory'];
        if (distributor?.distributorTypeCode?.toLowerCase() === 'smining' && paths.includes(location?.pathname?.toLowerCase()) && !isWacMixedFleetDistributor) {
            const confimObject = {
                title: 'Message',
                message: t(RESOURCE.MyK_Label_SMining_Distributor_Message),
                confirmmessage: '',
                buttonLabel: {
                    yes: t(RESOURCE.MyK_Label_OK),
                },
                yesOnclick: () => {},
                hideNoButton: true
            }
            confirmDailog(confimObject);
        } else {
        setValues({
            ...values,
            [name]: title[0],
        });

        if (name?.toLowerCase() == "distributors") {
            if (title[0] == t(RESOURCE.MyK_Label_AllDistributors)) {
                setValues({
                    distributors: t(RESOURCE.MyK_Label_AllDistributors),
                    distributorCode: "",
                    distributorId:"",
                    customer: t(RESOURCE.MyK_Label_AllCustomers),
                    customerId: "",
                    locations: t(RESOURCE.MyK_Label_AllLocations),
                    locationId: "",
                });
                setCustomerOptions([...initialState]);
                setLocationOptions([...initialState]);
                setDistributorCheck(false);
                setCustomerCheck(false);
                setLocationsCheck(false);
                    setUpdateSessionData((prevState) => ({
                        ...prevState,
                        DistributorId: "",
                        DistributorCode: "",
                        DistributorName: "",
                        CustomerId: "",
                        CustomerName: "",
                        LocationId: "",
                        LocationName: "",
                        BranchCode: "",
                        BranchName:"",
                        isClear: true,
                    }));
            } else {
                let distributorOpt = distributorOptions?.filter((d) => d.name == title[0])[0];
                let distCode = distributorOpt?.id ?? "";
                let distId = distributorOpt?.dbId ?? "";
                getCustomer(userId, distCode);
                setCustomerOptions([...initialState]);
                setLocationOptions([...initialState]);
                setValues((prevState) => ({
                    ...prevState,
                    distributors: title[0],
                    distributorCode: distCode,
                    distributorId: distId,
                    customer: t(RESOURCE.MyK_Label_AllCustomers),
                    customerId: "",
                    locations: t(RESOURCE.MyK_Label_AllLocations),
                    locationId: "",
                }));
                setDistributorCheck(true);
                setCustomerCheck(false);
                setLocationsCheck(false);
                    setUpdateSessionData((prevState) => ({
                        ...prevState,
                        DistributorCode: distCode,
                        DistributorId: distId,
                        DistributorName: title[0],
                        CustomerId: "",
                        CustomerName: "",
                        LocationId: "",
                        LocationName: "",
                        BranchCode: "",
                        BranchName: "",
                        isClear: false,
                    }));
                }
            }
        if (name?.toLowerCase() == "customer") {
            let distcode =
                values?.distributors != null
                    ? distributorOptions?.filter((d) => d.name == values?.distributors)[0]?.id ??
                    values?.distributorCode
                    : "";
            if (title[0] == t(RESOURCE.MyK_Label_AllCustomers)) {
                setValues((prevState) => ({
                    ...prevState,
                    customer: t(RESOURCE.MyK_Label_AllCustomers),
                    customerId: "",
                    locations: t(RESOURCE.MyK_Label_AllLocations),
                    locationId: "",
                }));
                setLocationOptions([...initialState]);
                setCustomerCheck(false);
                setLocationsCheck(false);
                    setUpdateSessionData((prevState) => ({
                        ...prevState,
                        CustomerId: "",
                        CustomerName: "",
                        LocationId: "",
                        LocationName: "",
                        isClear: false,
                    }));
            } else {
                let idx = customerOptions?.filter((t) => t.name == title[0])
                let custid: any;
                if (idx.length > 1) {
                    const filteredIndex = idx.find((t) => t.id === value);
                    custid = filteredIndex?.id;
                } else {
                    custid = idx[0]?.id;
                }
                let custCode = custid ?? values.customerId;
                getLocation(userId, distcode, custCode);
                setValues((prevState) => ({
                    ...prevState,
                    customer: title[0],
                    customerId: custCode,
                    locations: t(RESOURCE.MyK_Label_AllLocations),
                    locationId: "",
                }));
                setCustomerCheck(true);
                setLocationsCheck(false);
                    setUpdateSessionData((prevState) => ({
                        ...prevState,
                        CustomerId: custCode,
                        CustomerName: title[0],
                        isClear: false,
                        LocationId: "",
                        LocationName: ""
                    }));
                }
            }
        if (name?.toLowerCase() == "locations") {
            if (title[0] == t(RESOURCE.MyK_Label_AllLocations)) {
                    setLocationsCheck(false);
                    setUpdateSessionData((prevState) => ({
                        ...prevState,
                        LocationId: "",
                        LocationName: "",
                        isClear: false,
                    }));
                return;
            } else {
                setLocationsCheck(true);
                setUpdateSessionData((prevState) => ({
                    ...prevState,
                    LocationId: value,
                    LocationName: title[0],
                    isClear: false,
                }));
            }
            setValues((prevState) => ({
                ...prevState,
                locations: title[0],
                locationId: value,
            }));
        }
        }
    };

    const [breadcrumitems, setBreadcrumbItem] = useState<any>([]);
    const { breadcrumb } = useSelector((state) => ({
        breadcrumb: homeSelector.breadcrumb(state),
    }));

    useEffect(() => {
        if (!isLocationLoading && !isCustomerLoading && !isSessionUpdateLoading) {
            setIsLoading(false);
        }
    }, [isLocationLoading, isCustomerLoading, isSessionUpdateLoading]);

    useEffect(() => {
        getComponetsName();
        getDistributor();
        let list = breadcrumb.map((item: any, index: number) => {
            if (index !== breadcrumb.length) {
                return { text: item, key: item };
            } else {
                return { text: item, key: item, isCurrentItem: true };
            }
        });

        setBreadcrumbItem(list);
    }, []);

    useEffect(() => {
        if (!props?.isFromShoppingCart) {
            setSessionData();
        }
    }, [updateSessionData]);

    const messageTemplate = () => {
        return (
            <div className='messageTemplatebody messageAlign'>
                <b className="messageinfo">
                    {t(RESOURCE.MyK_Label_SC_Branch_Change_Confirm)}
                </b>
                <p>{t(RESOURCE.MyK_Label_SC_Branch_Change_ConfirmInfo)}</p>
            </div>
        );
    };
    let buttons = [
       
        {
            label: t(RESOURCE.MyK_Label_Cancel),
            title: t(RESOURCE.MyK_Label_Cancel),
            onClick: () => { }
        },
        {
            label: t(RESOURCE.MyK_Label_SC_Confirm),
            title: t(RESOURCE.MyK_Label_SC_Confirm),
            className:"btnYellow",
            onClick: () => {
                setSessionData();
                if (props?.shoppingcartOnClick) {
                    props.shoppingcartOnClick();
                }
            },
        },
    ];

    useEffect(() => {
        if (props?.isShopingCartUpdate) {
            props?.setIsShopingCartUpdate(false);
            props?.setCurrentViewModal(false);
            if (props?.isCheckoutPage) {
                confirmAlert({
                    title: t(RESOURCE.MyK_Label_Confirm_Title),
                    overlayClassName: "overlay-custom-class-name",
                    closeOnEscape: false,
                    message: messageTemplate() as any,
                    buttons: buttons,
                    closeOnClickOutside: false,
                    keyCodeForClose: [8, 32],
                });
            }
            else {
                setSessionData();
                if (locationpageName?.indexOf('orderdetails') > -1) {
                    helperfunctions.redictBackToOrderTrackingOrHistory(navigate);
                }
            }
        }
    }, [props?.isShopingCartUpdate]);

    useEffect(() => {
        if (props?.isFromShoppingCart) {
            if (updateSessionData?.LocationId != "" && updateSessionData?.CustomerId != "" && updateSessionData?.DistributorCode != ""
                && updateSessionData?.LocationId != null && updateSessionData?.CustomerId != null && updateSessionData?.DistributorCode != null) {
                props?.setIsUpdateButtonEnable(true);
            }
            else {
                props?.setIsUpdateButtonEnable(false);
            }
        }
    }, [updateSessionData?.LocationId, updateSessionData?.CustomerId, updateSessionData?.DistributorCode]);

    if (distributorOptions?.length > 0) {
        optionsDistributor = distributorOptions?.map((s: any) => ({
            ...s,
            value: s?.name,
            title: s?.name,
        }));
        optionsDistributor.unshift({
            value: t(RESOURCE.MyK_Label_AllDistributors),
            title: t(RESOURCE.MyK_Label_AllDistributors),
        });
    }
    if (customerOptions?.length > 0) {
        optionsCustomers = customerOptions
            ?.filter((s) => s?.id !== "")
            ?.map((s: any) => ({
                ...s,
                value: s?.id,
                title: s?.name,
            }));
        optionsCustomers.unshift({
            value: t(RESOURCE.MyK_Label_AllCustomers),
            title: t(RESOURCE.MyK_Label_AllCustomers),
        });
    }
    if (locationOptions?.length > 0) {
        optionsLocations = locationOptions
            ?.filter((s) => s?.id !== "")
            ?.map((s: any) => (
                {
                    ...s,
                    value: s?.id,
                    title: s?.name,
                    className: s?.selected ? 'mainIconFlag' : ''
                }));
        optionsLocations.unshift({
            value: t(RESOURCE.MyK_Label_AllLocations),
            title: t(RESOURCE.MyK_Label_AllLocations),
        });
    }

    const getRoleBasedVisible = () => {
        helperfunctions.isVisibleBasedOnRole(
            headercurrentuser?.isPLM,
            headercurrentuser?.isVHMS,
            headercurrentuser?.isInternationDbUser,
            headercurrentuser?.usertype?.name.toLowerCase()
        );
    }

    const userType = (headercurrentuser?.usertype?.name != undefined && headercurrentuser?.usertype?.name != null) ? headercurrentuser?.usertype?.name : "customer";

    useEffect(() => {
        if (headercurrentuser?.usertype?.name) {
            getRoleBasedVisible();
        }
    }, [headercurrentuser?.usertype?.name])


    useEffect(() => {
        if (values.locations == t(RESOURCE.MyK_Label_AllLocations) || values.locations == "") {
            setLocationsCheck(false);
        }

        if (values.locations == "") {
            setValues(
                (prevState) => ({
                    ...prevState,
                    locations: t(RESOURCE.MyK_Label_AllLocations),
                    locationId: "",
                })
            );
        }
    }, [locationsCheck, values])

    return (
        <CommonControl
            optionsDistributor={optionsDistributor}
            optionsCustomers={optionsCustomers}
            optionsLocations={optionsLocations}
            values={values}
            breadcrumitems={breadcrumitems}
            handleOnChange={handleOnChange}
            distributorCheck={distributorCheck}
            customerCheck={customerCheck}
            locationsCheck={locationsCheck}
            componentsRenderName={getBreadcrubPage}
            getBreadcrubPageactual={getBreadcrubPageactual}
            clearAllFields={clearAllFields}
            roleBasedfilterOptions={getRoleBasedVisible}
            userRoleType={userType}
            isLoading={isLoading}
            isUpdateClick={props?.isUpdateClick}
        />
    );
};

export default CommonControlContainer;
